import { skipToken, useQuery } from '@tanstack/react-query';

import { GET_PENDING_TEAM_INVITATIONS } from '../../contracts/keys';
import { listPendingTeamInvitations } from '../api/teams';
import { getWorkspaceDataConfig } from '../config';

export { GET_PENDING_TEAM_INVITATIONS };

/**
 * Invitations the caller can still answer. Distinct from the switcher's
 * `useQueryWorkspaceInvitations`: team-shaped, and ungated by multi-workspace.
 */
export function useQueryPendingTeamInvitations({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const token = getWorkspaceDataConfig().useAuthToken();

  return useQuery({
    queryKey: [GET_PENDING_TEAM_INVITATIONS],
    staleTime: 60 * 1000,
    queryFn:
      token && enabled
        ? async () => {
            const { data } = await listPendingTeamInvitations();
            return data;
          }
        : skipToken,
  });
}
